<template>
  <b-card no-body class="card-map-tij overflow-hidden h-100" >
    <b-row no-gutters class="h-100">
      <b-col md="6">
        <b-card-body title="Corporativo Tijuana">
          <b-card-text>
            Carretera Aeropuerto No. 3 interior 6, Garita de Otay
            <br>Tijuana, B.C México
            <br>Teléfono: (664) 9768916
            <br>
            <br>
          </b-card-text>
        </b-card-body>
      </b-col>
      <b-col md="6" class="d-flex justify-content-center">
        <div class="mapouter">
          <div class="gmap_canvas">
            <iframe width="100%" height="100%" id="gmap_canvas" src="https://maps.google.com/maps?q=Carretera%20Aeropuerto%20No.%203%20interior%206%2C%20Garita%20de%20Otay%20Tijuana%2C%20B.C%20M%C3%A9xico&t=&z=13&ie=UTF8&iwloc=&output=embed" frameborder="0" scrolling="no" marginheight="0" marginwidth="0">
            </iframe>
          </div>
        </div>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
export default {
  name: 'MapCardTijuana'
}
</script>

<style>
.card{
  margin: 0 0;
}
.mapouter{position:relative;text-align:right;height:100%;width:100%;}
.gmap_canvas {overflow:hidden;background:none!important;height:100%;width:100%;}
</style>
